import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { getConfig } from '@b2ag/micro-front-tools'

export function getAnalyticsMetaDataPayload(router, from, store) {
  let referrerDomainName
  try {
    const { referrer } = window.document
    referrerDomainName = new URL(referrer).host
  } catch (_: any) {
    referrerDomainName = window.location.host
  }

  let pageType = router.meta?.analyticsPageType
  if (!pageType && router.matched?.length) {
    pageType =
      router.matched
        .slice()
        .reverse()
        .find((matchedRoute) => matchedRoute.meta?.analyticsPageType) || router.name
  }
  const getPageTitle = () => {
    const matchedRoute = router.matched[router.matched.length - 1]
    if (!matchedRoute || !matchedRoute.instances) return document.title

    const instance = matchedRoute.instances.default
    return instance?.$metaInfo?.title || document.title
  }

  return {
    page_path: router.path,
    domain_name: window.location.host,
    url: router.fullPath,
    referrer_path: from.path,
    referrer_domain_name: referrerDomainName,
    referrer_url: from.fullPath,
    page_name: router.name,
    page_title: getPageTitle(),
    page_category: pageType,
    consent_customer_analytics: store.getters.user?.current_profile?.consent || false,
    environment: getConfig('ENVIRONMENT_NAME'),
    login_status: store.getters.user?.id ? 1 : 0,
    cooperative_id: store.getters.currentCooperativeId || null,
    cooperative_name: store.getters.currentCooperativeName || null,
    membership_number: store.getters.currentProfile?.membershipNumber || null,
    id_client: (store.getters.user?.id && `${store.getters.user.id}`) || null,
    user_type: (store.getters.user?.id && 'customer') || null,
    is_web_view: isWebViewFarmi(),
  }
}
